/** Normalize PGDashboard / InternalUserDashboard `links` into renderable groups. */

export function resolveDashboardSectionTitle(title, sectionTitle, variant = "pg") {
  if (sectionTitle) return sectionTitle;
  if (title && variant === "pg" && /professional\s*guardian/i.test(String(title))) {
    return "Professional Guardian Actions";
  }
  if (
    title &&
    (variant === "internal" || variant === "lawFirm") &&
    /law\s*f?irm/i.test(String(title))
  ) {
    return "Law Firm Actions";
  }
  return "Quick Actions";
}

function flattenDashboardLinks(links) {
  if (!Array.isArray(links)) return [];
  if (Array.isArray(links[0])) return links.flat();
  return links;
}

export function getDashboardLinkKey(link) {
  return link?.path || link?.name || "dashboard-link";
}

export function normalizeDashboardGroups(links, { title, sectionTitle, variant = "pg" } = {}) {
  const normalizedLinks = flattenDashboardLinks(links);

  const displayedSectionTitle = resolveDashboardSectionTitle(title, sectionTitle, variant);

  const isGroupedStructure =
    Array.isArray(links) &&
    links.length > 0 &&
    !Array.isArray(links[0]) &&
    typeof links[0] === "object" &&
    Array.isArray(links[0].values);

  if (isGroupedStructure) {
    return links.map((group) => ({
      title: group?.action_value || displayedSectionTitle,
      description: group?.action_description,
      items: Array.isArray(group?.values) ? group.values : [],
    }));
  }

  return [{ title: displayedSectionTitle, items: normalizedLinks }];
}
